export default __webpack_public_path__ + "static/media/q19_02.d833ee19.png";